"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Delete = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.gray,
  fillRule: "evenodd",
  d: "M487.779 11.366l.469.468c15.67 15.935 15.67 41.49 0 57.425L310.497 250.003l177.75 180.738c15.67 15.934 15.67 41.49 0 57.425-14.155 14.394-36.608 15.68-52.243 3.731l-4.227-3.731L250 303.334 68.223 488.166c-15.335 15.594-40.408 15.804-56.002.468l-.469-.468c-15.67-15.935-15.67-41.49 0-57.425l177.704-180.738L11.752 69.259c-15.67-15.934-15.67-41.49 0-57.425C25.908-2.56 48.361-3.846 63.996 8.103l4.227 3.731L250 196.666 431.777 11.834c15.335-15.594 40.408-15.804 56.002-.468z"
}));

var _default = Delete;
exports.default = _default;